<div class="">
  <form  *ngIf="refundForm" [formGroup]="refundForm" (ngSubmit)="submitRequest()">
    <div class="track-items-detail-panel p-3 element-curve beet ng-star-inserted">
      <div class="">
        <h2>Refund COD Request</h2>

        <div class="form-group">
          <div class="row"> 
            <div class="col-md-6"> 
              <!-- <input class="form-control" formControlName="consignmentNumber" placeholder="Consignment no."> -->
              <mat-form-field appearance="outline">
                <mat-label>Consignment no.</mat-label>
                <input matInput placeholder="Consignment no." style="border-color: red;">
                <mat-hint>Hint</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-md-6"> 
              <select class="form-control" [formControl]="refundForm.controls['refundReason']">
                <option value="" disabled hidden>Refund Reason</option>
                <option *ngFor="let option of refundReason" [value]="option.value">
                  {{ option.display }}
                </option>
              </select>
            </div>
          </div>
        </div>
        
        

        <div class="form-group">
          <label>Attach Document (Photo/Video Evidence)</label>
          <input type="file" (change)="onFileChange($event,'evidence')" class="upload-btn">
          <div class="row mt-4">
            <!-- Preview each selected file -->
            <div class="col-md-3" *ngFor="let file of evidenceFiles; let i = index">
              <div class="card">
                <img [src]="file.preview" class="card-img-top square-preview" alt="File Preview" *ngIf="file.type.startsWith('image/')">
                <video *ngIf="file.type.startsWith('video/')" class="card-img-top square-preview" controls>
                  <source [src]="file.preview" type="{{ file.type }}" />
                </video>
                <button class="btn btn-danger" (click)="removeImage(i, 'evidence')">Remove</button>
              </div>
            </div>
          </div>

          <input type="textbox" [value]="getImageUrlsString('evidence')" id="evidenceimageUrls" name="evidenceimageUrls" />

        </div>

        <hr/>

        <h3>Buyer Information</h3>
        <div class="col-md-12">
          <mat-tab-group class="custom-tab-group" animationDuration="0ms">
            <mat-tab label="personal">
              <div class="tab-content">
                <div class="form-group row">
                  <div class="col-md-6">
                    <select formControlName="identityType" id="identityType" class="form-control">
                      <option value="idCard" selected>ID Card</option>
                      <option value="Passport">Passport</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <input type="text" formControlName="identityNumber" placeholder="ID card number" class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <input type="text" formControlName="nameSurname" placeholder="Name surname" class="form-control">
                  </div>
                </div>
              
                <div class="form-group row">
                  
                  <div class="col-md-6">
                    <input type="text" formControlName="phoneNumber" placeholder="Phone number" class="form-control">
                  </div>
                  <div class="col-md-6">
                    <input type="email" formControlName="email" placeholder="Email" class="form-control">
                  </div>
                </div>
              
                <div class="form-group row">
                  <div class="col-md-6">
                    <input type="text" formControlName="address" placeholder="Address" class="form-control">
                  </div>
                  <div class="col-md-6">
                    <input type="text" formControlName="postalCode" placeholder="Postal code" class="form-control">
                  </div>
                </div>
              
                <div class="form-group row">
                  <label class="col-md-12">Attach Copy of ID Card/Passport</label>
                  <div class="col-md-12">
                    <input type="file" (change)="onFileChange($event,'idCard')" class="upload-btn" accept=".pdf,.doc,.docx">
                    <div class="row mt-12">
                      <div class="col-md-12" *ngFor="let file of idCardFiles; let i = index">
                        <div class="card">
                          <iframe *ngIf="file.type === 'application/pdf'" [src]="safePreviewUrl" class="pdf-preview" frameborder="0"></iframe>
                          <img [src]="file.preview" class="card-img-top square-preview" alt="File Preview" *ngIf="file.type.startsWith('image/')" />
                          <button class="btn btn-danger" (click)="removeImage(i, 'idCard')">Remove</button>
                        </div>
                      </div>
                    </div>
                    <input type="text" [value]="getImageUrlsString('idCard')" id="idCardimageUrls" name="idCardimageUrls" class="form-control" />
                  </div>
                </div>
              
                <div class="form-group row">
                  <label class="col-md-12">Copy of Name Change Certificate (Optional)</label>
                  <div class="col-md-12">
                    <input type="file" (change)="onFileChange($event,'nameChange')" class="upload-btn">
                    <div class="row mt-12">
                      <div class="col-md-12" *ngFor="let file of nameChangeFiles; let i = index">
                        <div class="card">
                          <img [src]="file.preview" class="card-img-top square-preview" alt="File Preview" *ngIf="file.type.startsWith('image/')">
                          <video *ngIf="file.type.startsWith('video/')" class="card-img-top square-preview" controls>
                            <source [src]="file.preview" type="{{ file.type }}" />
                          </video>
                          <button class="btn btn-danger" (click)="removeImage(i, 'nameChange')">Remove</button>
                        </div>
                      </div>
                    </div>
                    <input type="text" [value]="getImageUrlsString('nameChange')" id="nameChangeimageUrls" name="nameChangeimageUrls" class="form-control" />
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="company">
              <div class="tab-content">
                <div class="form-group row">
                  <div class="col-md-6">
                    <select formControlName="CompanyType" id="CompanyType" class="form-control">
                      <option value="headOfficeType" selected>Head office</option>
                      <option value="branchType">Branch</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <input type="text" id="branchCode" formControlName="branchCode" placeholder="Branch Code">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6">
                    <input type="text" formControlName="taxId" placeholder="Tax ID number">
                  </div>
                  <div class="col-md-6">
                    <input type="text" formControlName="companyName" placeholder="Company Name">
                  </div>
                </div>
                <div class="form-group row">
                  
                  <div class="col-md-6">
                    <input type="text" formControlName="phoneNumber" placeholder="Phone number">
                  </div>
                  <div class="col-md-6">
                    <input type="email" formControlName="email" placeholder="Email">
                  </div>
                </div>
                <!-- <div class="form-group row">
                  <div class="col-md-6">
                  <input type="text" formControlName="address" placeholder="Address">
                  </div>
                  <div class="col-md-6">
                    <input type="text" formControlName="postalCode" placeholder="Postal code">
                  </div>
                </div> -->
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        
        <hr/>

        <h3>Bank Account Information</h3>

        <div class="form-group row">
          <div class="col-md-6">
            <input type="text" formControlName="bank" placeholder="Bank">
          </div>
          <div class="col-md-6">
            <input type="text" formControlName="bankAccountNumber" placeholder="Bank account no.">
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <input type="text" formControlName="accountName" placeholder="Account name">
          </div>
        </div>
        <div class="form-group">
          <label>Attach Copy of Bank Account Book</label>
          <!-- <input type="file" class="upload-btn"> -->

          <input type="file" (change)="onFileChange($event,'bankAccount')" class="upload-btn" >
          <div class="row mt-4">
            <!-- Preview each selected file -->
            <div class="col-md-3" *ngFor="let file of bankAccountFiles; let i = index">
              <div class="card">
                <img [src]="file.preview" class="card-img-top square-preview" alt="File Preview" *ngIf="file.type.startsWith('image/')">
                <video *ngIf="file.type.startsWith('video/')" class="card-img-top square-preview" controls>
                  <source [src]="file.preview" type="{{ file.type }}" />
                </video>
                <button class="btn btn-danger" (click)="removeImage(i, 'bankAccount')">Remove</button>
              </div>
            </div>
          </div>

          <input type="textbox" [value]="getImageUrlsString('bankAccount')" id="bankAccountimageUrls" name="bankAccountimageUrls" />

        </div>
        <div class="form-group col-md-12 d-flex align-items-center">
          <input type="checkbox" formControlName="agreeTerms" id="agreeTerms" class="mr-2 ng-dirty ng-touched ng-invalid">
          <label for="agreeTerms" class="col-md-11">
            I hereby acknowledge that I have read, understood, and agree to the Terms and Conditions of COD refund and Privacy Notice
          </label>
        </div>
        <button type="submit" class="submit-btn">Confirm Request</button>
      </div>
    </div>
  </form>
</div>